import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop(props) {
  useEffect(() => {
    const unlisten = props.history.listen(() => {
      window.scrollTo(0, 0);
    });

    // Also on the first load (21 Oct 2026). Visitors arriving from an ad on a
    // slow connection see a blank page for a while and swipe; when the site
    // then renders, the browser keeps that position and they land partway
    // down instead of on the job form. Once everything has loaded, start at
    // the top, unless the address names an anchor on the page.
    const toTopOnLoad = () => {
      if (!window.location.hash) {
        window.scrollTo(0, 0);
      }
    };
    if (document.readyState === 'complete') {
      toTopOnLoad();
    } else {
      window.addEventListener('load', toTopOnLoad);
    }

    return () => {
      unlisten();
      window.removeEventListener('load', toTopOnLoad);
    };
  }, []);

  return props.children;
}

export default withRouter(ScrollToTop);
